import flatMap from 'lodash/flatMap';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import has from 'lodash/has';

import { CONTEXT_TYPE } from './order.model';

export interface IBumpScreenConfig {
  bump_frequency: number;
  exclude_orders_after: number;
  only_send_pos_failed_orders?: boolean;
}

export interface IBumpScreenContext {
  id: string;
  context_type: string;
  timeperiod: string;
  preorder_days?: number;
  is_collect_at_counter?: boolean;
  food_drink_split?: boolean;
}

export interface IBumpScreenLocation {
  id: string;
  contexts: IBumpScreenContext[];
  timezone: string;
  title: string;
}

export class Bump_screen {
  public id: string;
  public access_key: string;
  public title: string;
  public source: any;

  /** The account id of the merchant */
  public account_id: string;

  /** The account name of the merchant */
  public account: string;

  /** The account logo of the merchant */
  public account_logo: string[];

  /** Ready to Serve screen specific configuration */
  public config: IBumpScreenConfig;

  /** The list of locations attached to Ready to Serve screen */
  public location_details: IBumpScreenLocation[];

  /** For storage purposes */
  public expiry: any;

  /** For storage purposes */
  public print_count: number = 1;

  /** NEW v2 */
  public availableContextModules: string[] = [];
  public use_recording: boolean = true;

  /** Number of max preorders days of the bump screen */
  private _max_preorder_days: number = 1;

  /** The available printer groups of the bump screen */
  public printing_groups: any[];

  constructor(screen: any) {
    // save the original data
    this.source = screen;

    // the code below is redundant but we might need future data manipulation
    // so leave it as is for now

    this.id = screen.id;
    this.access_key = screen.access_key;
    this.title = screen.title;
    this.account = screen.account;
    this.account_logo = screen.account_logo;
    this.account_id = screen.account_id;
    this.config = screen.config;
    this.location_details = screen.location_details;
    this.use_recording = true;
    this.print_count = screen.print_count ? screen.print_count : 1;
    this.printing_groups = screen.printing_groups;

    try {
      // prepare preorder days
      let hasPreorderdays: boolean = false;
      for (let location of this.location_details) {
        for (let context of location.contexts) {
          if (has(context, 'preorder_days')) {
            hasPreorderdays = true;
            this._max_preorder_days = Math.max(context.preorder_days, this._max_preorder_days);
          }
        }
      }

      if (!hasPreorderdays) {
        this._max_preorder_days = 7;
      }
    } catch (e) {}

    this._groupContextModules();
  }

  /**
   * Creates a unique list of contexts based on types
   */
  private _groupContextModules(): void {
    this.availableContextModules = flatMap(this.location_details, (location: IBumpScreenLocation) => {
      return map(location.contexts, (context: IBumpScreenContext) => {
        return context.context_type == CONTEXT_TYPE.Dine_in && context.is_collect_at_counter
          ? 'collect_at_counter'
          : context.context_type;
      });
    });

    this.availableContextModules = uniq(this.availableContextModules);
  }

  /**
   * Returns the maximum preorder days of a context type
   * @param contextType The context type. Sending 'all' will return the max preorder days based on ALL contexts.
   */
  public getPreorderDaysByFulfillment(contextType: string): number {
    let retVal: number = 1;

    if (!contextType || contextType == 'all') {
      return this.Max_preorder_days;
    }

    // dinein always return 1
    if (contextType == CONTEXT_TYPE.Dine_in) {
      return 1;
    }

    let hasMaxPreorderDays: boolean = false;
    for (let location of this.location_details) {
      for (let context of location.contexts) {
        if (context.context_type == contextType) {
          if (has(context, 'preorder_days')) {
            retVal = Math.max(context.preorder_days, retVal);
            hasMaxPreorderDays = true;
          }
        }
      }
    }

    if (!hasMaxPreorderDays) {
      return this.Max_preorder_days;
    }

    return retVal;
  }

  public export(): void {
    this.source['expiry'] = this.expiry;
    return this.source;
  }

  public get Max_preorder_days(): number {
    return this._max_preorder_days;
  }

  public get Only_send_pos_failed_orders(): boolean {
    return this.config && this.config.only_send_pos_failed_orders === true;
  }
}
